'use strict';

import { combineReducers } from 'redux';
import update from 'immutability-helper';
import { dateFromIsoString } from '@/state/utilities';

import * as types from './types';
import * as orderTypes from '../orders/types';

const byId = (
    state = {},
    action
) => {

	let attempt, attemptId;

    switch (action.type) {

        case types.FETCH_ATTEMPTS_COMPLETED:
		case types.FETCH_USER_DAILY_ATTEMPTS_COMPLETED:
		case types.FETCH_USER_WEEKLY_ATTEMPTS_COMPLETED:
            const attempts = {};

            action.data.attempts.forEach(a => {
                attempts[ a._id ] = a;
            });

            return { ...state, ...attempts };

		case types.POST_ATTEMPT_COMPLETED:
		case types.POST_EDIT_ATTEMPT_COMPLETED:
		case orderTypes.POST_COMPLETE_TASK_COMPLETED:
			({ attempt } = action.data);
			return { ...state, [ attempt._id ]: attempt };
			
		case types.POST_DELETE_ATTEMPT_COMPLETED:
		case orderTypes.POST_UNCOMPLETE_TASK_COMPLETED:
			({ attemptId } = action.meta.body);
			const { [ attemptId ]: a, ...filtered } = state;
			return filtered;

        default:
            return state;
    }
};

const allIds = (state = [], action) => {

    switch (action.type) {

		case types.POST_ATTEMPT_COMPLETED:
		case orderTypes.POST_COMPLETE_TASK_COMPLETED:
			return [ ...state, action.data.attempt._id ];

		case types.POST_DELETE_ATTEMPT_COMPLETED:
		case orderTypes.POST_UNCOMPLETE_TASK_COMPLETED:
			const { attemptId } = action.meta.body;
			return state.filter(id => id !== attemptId);

        case types.FETCH_ATTEMPTS_COMPLETED:
		case types.FETCH_USER_DAILY_ATTEMPTS_COMPLETED:
		case types.FETCH_USER_WEEKLY_ATTEMPTS_COMPLETED:
			return [ ...new Set([
				...state,
				...action.data.attempts.map(a => a._id)
			])];

        default:
            return state;
    }
};

const idsByUserDate = (state = {}, action) => {

	let username, date, attemptId, attempts;

    switch (action.type) {

		case types.POST_ATTEMPT_COMPLETED:
		case orderTypes.POST_COMPLETE_TASK_COMPLETED:

			({ username } = action.meta.params);
			const { attempt } = action.data;
			date = dateFromIsoString(attempt.date);
			
			if (username in state) {
				if (date in state[ username ]) {
					return {
						...state,
						[ username ]: {
							...state[ username ],
							[ date ]: [ ...state[ username ][ date ], attempt._id ]
						}
					};
				} else {
					return {
						...state,
						[ username ]: {
							...state[ username ],
							[ date ]: [ attempt._id ]
						}
					};
				}
			}

			return {
				...state,
				[ username ]: {
					[ date ]: [ attempt._id ]
				}
			};

		case orderTypes.POST_UNCOMPLETE_TASK_COMPLETED:

			({ attemptId } = action.meta.body);
			({ username, date } = action.meta.params);

			if (username in state && date in state[ username ]) {

				const ids = state[ username ][ date ] || [];

				return {
					...state,
					[ username ]: {
						...state[ username ],
						[ date ]: ids.filter(id => id !== attemptId)
					}
				}
			}

			return state;

		case types.FETCH_USER_DAILY_ATTEMPTS_COMPLETED:

			({ attempts } = action.data);
			({ username, date } = action.meta.body);

			if (username in state) {
				return {
					...state,
					[ username ]: {
						...state[ username ],
						[ date ]: attempts.map(a => a._id)
					}
				};
			} else {
				return {
					...state,
					[ username ]: {
						[ date ]: attempts.map(a => a._id)
					}
				};
			}

			return state;

		case types.FETCH_USER_WEEKLY_ATTEMPTS_COMPLETED:

			({ attempts } = action.data);
			({ username, date } = action.meta.body);

			const byDay = {};

			attempts.forEach(a => {
				if (!(a.day in byDay)) {
					byDay[ a.day ] = [];
				}
				byDay[ a.day ].push(a._id);
			});

			const userDays = (username in state) ? { ...state[ username ] } : {};

			for (const day in byDay) {
				if (day in userDays) {
					userDays[ day ] = [ ...new Set([
						...userDays[ day ],
						...byDay[ day ]
					])];
				} else {
					userDays[ day ] = byDay[ day ];
				}
			}
			
			return {
				...state,
				[ username ]: userDays
			};

		case types.POST_DELETE_ATTEMPT_COMPLETED:
			({ username, date, attemptId } = action.meta.body);

			if (username in state && date in state[ username ]) {
				return state[ username ][ date ].filter(id => id !== attemptId);
			}

			return state;

		default:
			return state;
	}
};
const attempts = combineReducers({
    byId,
    allIds,
	idsByUserDate
});

export default attempts;
